/**
 * Reads Vite `import.meta.env` for Delivery API, Pathfinder iframe, and dev/mock flags.
 * Production embeds inject these at build time; see README “Configuration”.
 */

export function isDeliveryConfigured(): boolean {
  return Boolean((import.meta.env.VITE_UMBRACO_DELIVERY_BASE ?? '').trim());
}

/** Base URL for Delivery API content endpoint (throws if unset — call after `isDeliveryConfigured`). */
export function getDeliveryContentUrl(): string {
  const base = (import.meta.env.VITE_UMBRACO_DELIVERY_BASE ?? '').replace(/\/$/, '');
  if (!base) {
    throw new Error('VITE_UMBRACO_DELIVERY_BASE is required');
  }
  return `${base}/umbraco/delivery/api/v2/content/`;
}

/** Pathfinder origin (and optional path prefix) with trailing slash stripped. */
export function getPathfinderBaseUrl(): string {
  return (import.meta.env.VITE_PATHFINDER_BASE_URL ?? '').replace(/\/$/, '');
}

/** True when base URL and at least one allowed `postMessage` origin are set. */
export function isPathfinderConfigured(): boolean {
  return Boolean(getPathfinderBaseUrl()) && getPathfinderAllowedOrigins().length > 0;
}

/** Path segment after Pathfinder base; always starts with `/`. */
export function getPathfinderPath(): string {
  const p = import.meta.env.VITE_PATHFINDER_PATH ?? '/';
  return p.startsWith('/') ? p : `/${p}`;
}

/**
 * Exact origins (no trailing slash) for which `PATH_COMPLETE` iframe messages are accepted.
 */
export function getPathfinderAllowedOrigins(): string[] {
  const raw = import.meta.env.VITE_PATHFINDER_ALLOWED_ORIGINS ?? '';
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

/** When `VITE_USE_MOCK_QUIZ === 'true'`, skip Delivery and use `mock-quiz.ts`. */
export function useMockQuiz(): boolean {
  return import.meta.env.VITE_USE_MOCK_QUIZ === 'true';
}
